<div class="font-weight-normal">
  <i class="fas fa-info-circle"></i>
  <span translate
    >UI.Common.LanguageIndicatorPrefix<strong translate>
      UI.Common.LanguageIndicatorSuffix</strong
    >
  </span>
</div>
